import { useDispatch } from "react-redux";
import { Link, NavLink } from "react-router-dom"
import learningPortal from "../../assets/image/learningportal.svg"
import useUserInfo from "../../hooks/useUserInfo"
import { userLoggedOut } from "../../redux/features/auth/authSlice";

export default function AdminNavbar() {
  const user = useUserInfo()
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
  };
  return (
    <nav className="shadow-md">
      <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
        <Link to={"/admin/dashboard"} >
          <img className="h-10" src={learningPortal} alt="learning portal" />
        </Link>
        <div className="flex items-center gap-3">
          <NavLink to={"/admin/videos"} className={({ isActive }) => (isActive ? "bg-gray-500 px-2 py-1 rounded" : "lg:font-bold hover:bg-gray-500 px-2 py-1 rounded")}>Videos</NavLink>

          <NavLink className={({ isActive }) => (isActive ? "bg-gray-500 px-2 py-1 rounded" : "lg:font-bold hover:bg-gray-500 px-2 py-1 rounded")} to={"/admin/assignment"}>Assignment</NavLink>

          <NavLink to={"/admin/quizzes"} className={({ isActive }) => (isActive ? "bg-gray-500 px-2 py-1 rounded" : "lg:font-bold hover:bg-gray-500 px-2 py-1 rounded")}>Quizzes</NavLink>

          <NavLink to={"/admin/assignment-mark"} className={({ isActive }) => (isActive ? "bg-gray-500 px-2 py-1 rounded" : "lg:font-bold hover:bg-gray-500 px-2 py-1 rounded")}>Assignment Mark</NavLink>

          <h2 className="font-bold">{user?.name}</h2>
          <button
            onClick={logout}
            className="flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
              stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
            </svg>
            Logout
          </button>
        </div>
      </div>
    </nav>
  )
};